export const SUBSCRIPTION_HEADER = 'Upgrade Your Subscription to Access this Content';
export const CONTACT_US_LINK = 'https://know.creditsights.com/upgrade-your-plan/';
export const REQUEST_ACCESS_HEADER = 'Request Access';
